import Vue from 'vue';
import TabView from 'primevue/tabview';

Vue.component('TabView', TabView);
